// extracted by mini-css-extract-plugin
export default {"success":"rB84d","btn":"_2qdZD"};